// extracted by mini-css-extract-plugin
export default {"detailsLink":"ListItem_detailsLink__ILoJ0","detailsBox":"ListItem_detailsBox__hwBDq","detailsContainer":"ListItem_detailsContainer__qC49D","mainSpacer":"ListItem_mainSpacer__wCSxe"};